import { Response } from "@/shared/models/Response";
import axios from "axios";
import { DocumentPaginationDTO } from "../models/DocumentPaginationDTO";
import { DocumentQueryDTO } from "../models/DocumentQueryDTO";
import { DocumentSaveDTO } from "../models/DocumentSaveDTO";
import { DocumentUpdateDTO } from "../models/DocumentUpdateDTO";
import { SignUrlResponse } from "../models/signUrlResponse";

export class DocumentService {
  private baseUrl: string;
  constructor() {
    this.baseUrl = `${process.env.VUE_APP_FORMS_API}/documents`;
  }

  async getDocumentByFilter(
    query: DocumentQueryDTO
  ): Promise<Response<DocumentPaginationDTO | void>> {
    const response = await axios.get(`${this.baseUrl}/filter`, {
      params: query
    });
    return response.data;
  }

  async getDocumentsURL(id: string): Promise<Response<string | void>> {
    const response = await axios.get(`${this.baseUrl}/path/${id}`);
    return response.data;
  }

  async createDocumentRecord(
    documentSaveDTO: DocumentSaveDTO
  ): Promise<Response<string | void>> {
    const response = await axios.post(
      `${this.baseUrl}/create-record`,
      documentSaveDTO
    );
    return response.data;
  }

  async updateDocumentPath(
    documentUpdateDTO: DocumentUpdateDTO
  ): Promise<Response<void>> {
    const response = await axios.put(
      `${this.baseUrl}/update-path`,
      documentUpdateDTO
    );
    return response.data;
  }

  async updateDocument(
    documentUpdateDTO: DocumentUpdateDTO
  ): Promise<Response<void>> {
    const response = await axios.put(
      `${this.baseUrl}/update`,
      documentUpdateDTO
    );
    return response.data;
  }

  async deleteFailedDocument(deleteId: string): Promise<Response<void>> {
    const response = await axios.delete(`${this.baseUrl}/${deleteId}`);
    return response.data;
  }

  async getlimitSize(): Promise<Response<string | void>> {
    const response = await axios.get(`${this.baseUrl}/get-size-file`);
    return response.data;
  }

  async signUrl(documentToSign: {
    storagePath: string;
    documentId: string;
    userId: string;
  }): Promise<Response<SignUrlResponse>> {
    const response = await axios.post(
      `${this.baseUrl}/sign-url`,
      documentToSign
    );
    return response.data;
  }

  async shortUrl(documentToSign: {
    storagePath: string;
    documentId: string;
    userId: string;
  }): Promise<Response<SignUrlResponse>> {
    const response = await axios.post(
      `${this.baseUrl}/short-url`,
      documentToSign
    );
    return response.data;
  }
}
